import { debounce } from 'lodash';
import { useLayoutEffect } from 'react';

const useFontsLoader = (fontFamilies?: { url?: string }[]) => {
	useLayoutEffect(() => {
		// we want to remove families without URL (OOTB fonts)
		// and duplicate font URLs (if the user chosen the same font twice)
		const removeFns = fontFamilies
			?.filter(
				({ url }, idx) =>
					url && fontFamilies.findIndex((family) => family.url === url) === idx
			)
			.map((family) => {
				const linkEle = document.createElement('link');
				linkEle.rel = 'stylesheet';
				linkEle.href = family.url!;

				document.head.appendChild(linkEle);

				return () => {
					if (linkEle.parentElement) {
						document.head.removeChild(linkEle);
					}
				};
			});

		// if fonts are OOTB and should not be downloaded, we need to fake this event
		if (!removeFns?.length) {
			document.fonts.dispatchEvent(new Event('loadingdone'));
		}

		return () => {
			// this fn might be called several times because multiple fonts can be loaded
			// we want to make sure we are running the cleanup after all fonts are loaded
			const cleanup = debounce(() => {
				removeFns?.forEach((fn) => fn());
				document.fonts.removeEventListener('loadingdone', cleanup);
			}, 500);
			// we don't want to clean the previous fonts before adding the new one
			document.fonts.addEventListener('loadingdone', cleanup);
		};
	}, [fontFamilies]);
};

export default useFontsLoader;
